import axios, { AxiosError, type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';
import { appConfig } from './authConfig';
import { userManager } from './oidcClient';

let on401Handler: () => void = () => {
  void userManager.signinRedirect().catch(() => undefined);
};

export function setOn401Handler(handler: () => void): void {
  on401Handler = handler;
}

export const apiClient: AxiosInstance = axios.create({
  baseURL: appConfig.apiBaseUrl,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  try {
    const user = await userManager.getUser();
    if (user && !user.expired && user.access_token) {
      config.headers.set('Authorization', `Bearer ${user.access_token}`);
    }
  } catch {
    /* ignore — request will fall through unauthenticated */
  }
  return config;
});

apiClient.interceptors.response.use(
  (resp) => resp,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      on401Handler();
    }
    return Promise.reject(error);
  },
);
